<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar-menu></sidebar-menu>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title" :title1="title1" />

        <!-- /add -->
        <div class="card">
          <div class="card-body">
            <!-- <Form @submit="update" :validation-schema="schema" v-slot="{ errors }"> -->
            

            <div class="row">
              <div class="d-flex align-items-center">

                <div class="search-set " style="margin-top: 10px !important; margin-bottom: 0px !important;">
                  
                  <div class="search-input">
                      <a class="btn btn-searchset"><img src="@/assets/img/icons/search-white.svg"
                              alt="img" /></a>
                      <div id="DataTables_Table_0_filter" class="dataTables_filter">
                          <label>
                              <input type="search" class="form-control form-control-sm"
                                  placeholder="Search..." aria-controls="DataTables_Table_0"
                                  v-model="query" />
                          </label>
                      </div>
                  </div>
  
  
                    
                </div>
                <div class="wordset">
                    <ul>
                        <!-- <li class="" >
                            <router-link class=" d-flex flex-column justify-content-between  align-items-center " to="importschedule" style="margin-top: 15px !important; margin-bottom: 0px !important;"><vue-feather
                                    type="upload" class="text-success"></vue-feather> <span class="text-black">Import</span></router-link>
                        </li> -->

                        <li>
                            <div class="form-group" style="margin-top: 10px !important; margin-bottom: 0px !important;">
                                <div class="input-groupicon" style="z-index: 100;">
                                    <!-- <datepicker v-model="periode" class="picker" :editable="true"
                                        :clearable="false" @update:modelValue="index" /> -->
                                    <!-- <a class="addonset">
                                        <i class='bx bx-calendar'></i>
                                    </a> -->
                                    <DatePicker 
                                        v-model:value="periode" 
                                        type="date"
                                        range
                                        format="YYYY-MM-DD"
                                        value-type="format"
                                        :clearable="true"
                                        class="picker"
                                        
                                        style="width: 268px !important;" 
                                    />

                                    <!-- @change="onDateChange" pindahin ke datepicker klo harus langsung triggered ke index methods -->
                                </div>
                            </div>
                        </li>

                        <li class="d-flex align-items-center gap-3">
                            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Generate"
                                @click="generateData"
                                class="d-flex flex-column justify-content-center  align-items-center mt-2 btn btn-primary p-1">
                                <i class='bx bx-refresh' style="font-size: 25px;"></i> 
                                <!-- <span
                                    class="text-black">
                                    generate
                                </span> -->
                            </a>

                            <a data-bs-toggle="tooltip" data-bs-placement="top" title="excel"
                                @click="showModal('exportExcel')"
                                class="d-flex flex-column justify-content-center  align-items-center btn btn-primary p-1 mt-2"><img
                                    src="../../../assets/img/Import_fill.png" alt="img" width="25" /> 
                                    <!-- <span
                                    class="text-black">
                                    excel
                                </span> -->
                            </a>

                            <a data-bs-toggle="tooltip" data-bs-placement="top" title="Jtrust Template"
                                @click="showModal('exportJtrust')"
                                class="d-flex flex-column justify-content-center  align-items-center btn btn-primary p-1 mt-2">
                                <img src="https://hargabelanja.com/wp-content/uploads/gaji-karyawan-Bank-JTRUST-Indonesia.jpg" alt="img" width="25" style="border-radius: 5px;"/> 
                                    
                            </a>

                        </li>
  
                        
                        
  
                    </ul>
                </div>

              </div>
              
              <div class="table-responsive mt-3">
                  <a-table :columns="columns" :data-source="filteredData" :loading="loading">
                      <template #bodyCell="{ column, record }">
                          <template v-if="column.key === 'no'">
                              <div class="productimgname">
                                  {{ record.no }}
                              </div>
                          </template>
                          <!-- <template v-if="column.key === 'deskripsi'">
                              <div class="productimgname">
                                  {{ shortenDescription(record.deskripsi) }}
                              </div>
  
  
                          </template> -->

                          <template v-if="column.key === 'jumlah_hari'" >
                            <p class="text-end">

                              {{ Math.floor(record.jumlah_hari) }}
                            </p>
                              <!-- <div class="productimgname " >
                                 
                                  
                              </div> -->
  
  
                          </template>

                        <template v-if="column.key === 'gaji'">
                              <p class="text-end" >
                                  {{ rupiahNonIdr(record.gaji) }}
                              </p>
  
  
                          </template>
                          <template v-if="column.key === 'tunjangan_tetap'">
                              <p class="text-end" >
                                  {{ rupiahNonIdr(record.tunjangan_tetap) }}
                              </p>
  
  
                          </template>
                          <template v-if="column.key === 'tunjangan_tidak_tetap'">
                              <p class="text-end">
                                  {{ rupiahNonIdr(record.tunjangan_tidak_tetap) }}
                              </p>
  
  
                          </template>
                          <template v-if="column.key === 'tunjangan_makan'">
                              <p class="text-end">
                                  {{ rupiahNonIdr(record.tunjangan_makan) }}
                              </p>
  
  
                          </template>
                          <template v-if="column.key === 'tunjangan_kehadiran'">
                              <p class="text-end">
                                  {{ rupiahNonIdr(record.tunjangan_kehadiran) }}
                              </p>
  
  
                          </template>
                          <template v-if="column.key === 'tunjangan_transport'">
                              <p class="text-end">
                                  {{ rupiahNonIdr(record.tunjangan_transport) }}
                              </p>
  
  
                          </template>
                          <template v-if="column.key === 'tunjangan_lain'">
                              <p class="text-end">
                                  {{ rupiahNonIdr(record.tunjangan_lain) }}
                              </p>
  
  
                          </template>
                          <template v-if="column.key === 'tunjangan_lain2'">
                              <p class="text-end">
                                  {{ rupiahNonIdr(record.tunjangan_lain2) }}
                              </p>
  
  
                          </template>

                          <template v-if="column.key === 'additional'">
                              <p class="text-end">
                                  {{ rupiahNonIdr(record.additional) }}
                              </p>
  
  
                          </template>

                          <template v-if="column.key === 'deduction'">
                              <p class="text-end">
                                  {{ rupiahNonIdr(record.deduction) }}
                              </p>
  
  
                          </template>

                          <template v-if="column.key === 'bpjs_tenaga_kerja'">
                              <p class="text-end">
                                  {{ rupiahNonIdr(record.bpjs_tenaga_kerja) }}
                              </p>
  
  
                          </template>

                          <template v-if="column.key === 'bpjs_kesehatan'">
                              <p class="text-end">
                                  {{ rupiahNonIdr(record.bpjs_kesehatan) }}
                              </p>
  
  
                          </template>
                          
                          <template v-if="column.key === 'pph21'">
                              <p class="text-end">
                                  {{ rupiahNonIdr(record.pph21) }}
                              </p>
  
  
                          </template>

                          <template v-if="column.key === 'total_amount'">
                              <p class="text-end">
                                  {{ rupiahNonIdr(record.total_amount) }}
                              </p>
  
  
                          </template>
  
                          <!-- <template v-else-if="column.key === 'action'">
                              
                              <router-link class="me-3" to="editother_deduction" @click="edit(record);">
                                  <img src="@/assets/img/icons/edit.svg" alt="img" />
                              </router-link>
                              <a class="confirm-text" href="javascript:void(0);"
                                  @click="terminate(record.id, record.nama_departemen); showModal('terminate');">
                                  <img src="@/assets/img/icons/delete.svg" alt="img" />
                              </a>
                          </template> -->
                      </template>
                  </a-table>
              </div>
            </div>

          </div>
        </div>
        <!-- /add -->
      </div>
    </div>
  </div>


    <div class="modal fade" id="exportExcel" ref="exportExcel" tabindex="-1" role="dialog"
        aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">Export Excel</h5>
                    <button type="button" class="close" @click="hideModal2('exportExcel')" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <form @submit.prevent="insert">
                    <div class="modal-body">
                        <div class="form-group col-12">
                            <label for="">Pilih Branch</label>
                            <vue-select :options="branchList"
                                :settings="{ settingOption: value, settingOption: value }" 
                                v-model="exportBranch"
                                placeholder="None" 
                                @select="selectBranch" style=" border: 1px solid #09B67D; border-radius: 5px;">
                            </vue-select>
                        </div>
                    </div>
                    <div class="modal-footer d-flex justify-content-end">
                        <button type="button" class="btn btn-sm btn-secondary" @click="hideModal2('exportExcel')">cancel</button>
                        <button type="submit" class="btn btn-sm btn-primary">Export</button>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <!-- For JTrust modal export -->
    <div class="modal fade" id="exportJtrust" ref="exportJtrust" tabindex="-1" role="dialog"
        aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">Export JTrust</h5>
                    <button type="button" class="close" @click="hideModal2('exportJtrust')" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <form @submit.prevent="exportJtrustCSV">
                    <div class="modal-body">
                        <div class="form-group col-12">
                            <label for="">Pilih Branch</label>
                            <vue-select :options="branchList"
                                :settings="{ settingOption: value, settingOption: value }" 
                                v-model="exportBranch"
                                placeholder="None" 
                                @select="selectBranch" style=" border: 1px solid #09B67D; border-radius: 5px;">
                            </vue-select>
                        </div>
                    </div>
                    <div class="modal-footer d-flex justify-content-end">
                        <button type="button" class="btn btn-sm btn-secondary" @click="hideModal2('exportJtrust')">cancel</button>
                        <button type="submit" class="btn btn-sm btn-primary">Export</button>
                    </div>
                </form>
            </div>
        </div>
    </div>

</template>



<style>
.ant-picker-focused {
  border-color: #08b77e !important;
  box-shadow: 0 0 0 2px rgba(24, 255, 74, 0.2);
  border-right-width: 1px !important;
  outline: 0;
}

.ant-picker {
  border-radius: 5px !important;
}

.ant-picker:hover,
.ant-picker-focused {
  border-color: #08b77e !important;
  border-right-width: 1px !important;
}

.ant-table-cell .cell-right {
  text-align: right !important;

}

</style>
<script>
import Cookies from "js-cookie";
import axios from "axios";
import { base_url, AlertPopup2, AlertBottom, appendForm, timeout, selectedBranch, goPage, rupiah, rupiahNonIdr } from "@/assets/js/function";
import { ref, watch } from 'vue';

import DatePicker from 'vue-datepicker-next'
import 'vue-datepicker-next/index.css'



const month = ref({
  month: new Date().getMonth(),
  year: new Date().getFullYear()
});

export default {
  // components: {
  //   Form,
  //   Field,
  // },
  components: {
        DatePicker
        
  },

  name: "editemployee",
  data() {
    return {
      filter: true,
      title: "Payroll Report",
      title1: "generate payroll report",
      config: "",
      api: "",

      // periode: new Date(),
      periode: [],

      data: [],
      columns: [
              {
                  title: "No",
                  dataIndex: "no",
                  key: "no",
                  
                  sorter: {
                      compare: (a, b) => {
                          a = a.no.toLowerCase();
                          b = b.no.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "Employee ID",
                  dataIndex: "employee_id2",
                  key: "employee_id2",
                  
                  sorter: {
                      compare: (a, b) => {
                          a = a.employee_id2.toLowerCase();
                          b = b.employee_id2.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              
              {
                  title: "Employee",
                  dataIndex: "nama_karyawan",
                  key: "nama_karyawan",
                  
                  sorter: {
                      compare: (a, b) => {
                          a = a.nama_karyawan.toLowerCase();
                          b = b.nama_karyawan.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },

              {
                  title: "Work Days",
                  dataIndex: "jumlah_hari",
                  key: "jumlah_hari",
                  
                  sorter: {
                      compare: (a, b) => {
                          a = a.jumlah_hari.toLowerCase();
                          b = b.jumlah_hari.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "Salary",
                  dataIndex: "gaji",
                  key: "gaji",
                  
                  sorter: {
                      compare: (a, b) => {
                          a = a.gaji.toLowerCase().localeCompare(a.gaji.toLowerCase());
                          b = b.gaji.toLowerCase().localeCompare(b.gaji.toLowerCase());
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "Fixed Allowance",
                  dataIndex: "tunjangan_tetap",
                  key: "tunjangan_tetap",
                  
                  sorter: {
                      compare: (a, b) => {
                          a = a.tunjangan_tetap.toLowerCase().localeCompare(a.tunjangan_tetap.toLowerCase());
                          b = b.tunjangan_tetap.toLowerCase().localeCompare(b.tunjangan_tetap.toLowerCase());
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "Irregular Allowance",
                  dataIndex: "tunjangan_tidak_tetap",
                  key: "tunjangan_tidak_tetap",
                  // align: "right",
                  sorter: {
                      compare: (a, b) => {
                          a = a.tunjangan_tidak_tetap.toLowerCase();
                          b = b.tunjangan_tidak_tetap.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "Meal Allowances",
                  dataIndex: "tunjangan_makan",
                  key: "tunjangan_makan",
                  // align: "right",
                  sorter: {
                      compare: (a, b) => {
                          a = a.tunjangan_makan.toLowerCase();
                          b = b.tunjangan_makan.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "Attendance Allowance",
                  dataIndex: "tunjangan_kehadiran",
                  key: "tunjangan_kehadiran",
                  // align: "right",
                  sorter: {
                      compare: (a, b) => {
                          a = a.tunjangan_kehadiran.toLowerCase();
                          b = b.tunjangan_kehadiran.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "Transport Allowance",
                  dataIndex: "tunjangan_transport",
                  key: "tunjangan_transport",
                  // align: "right",
                  sorter: {
                      compare: (a, b) => {
                          a = a.tunjangan_transport.toLowerCase();
                          b = b.tunjangan_transport.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "Other Allowance",
                  dataIndex: "tunjangan_lain",
                  key: "tunjangan_lain",
                  // align: "right",
                  sorter: {
                      compare: (a, b) => {
                          a = a.tunjangan_lain.toLowerCase();
                          b = b.tunjangan_lain.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "Other Allowances 2",
                  dataIndex: "tunjangan_lain2",
                  key: "tunjangan_lain2",
                  // align: "right",
                  sorter: {
                      compare: (a, b) => {
                          a = a.tunjangan_lain2.toLowerCase();
                          b = b.tunjangan_lain2.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "additional",
                  dataIndex: "additional",
                  key: "additional",
                  // align: "right",
                  sorter: {
                      compare: (a, b) => {
                          a = a.additional.toLowerCase();
                          b = b.additional.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "Deduction",
                  dataIndex: "deduction",
                  key: "deduction",
                  // align: "right",
                  sorter: {
                      compare: (a, b) => {
                          a = a.deduction.toLowerCase();
                          b = b.deduction.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "BPJS TK",
                  dataIndex: "bpjs_tenaga_kerja",
                  key: "bpjs_tenaga_kerja",
                  // align: "right",
                  sorter: {
                      compare: (a, b) => {
                          a = a.bpjs_tenaga_kerja.toLowerCase();
                          b = b.bpjs_tenaga_kerja.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "BPJS Kesehatan",
                  dataIndex: "bpjs_kesehatan",
                  key: "bpjs_kesehatan",
                  // align: "right",
                  sorter: {
                      compare: (a, b) => {
                          a = a.bpjs_kesehatan.toLowerCase();
                          b = b.bpjs_kesehatan.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "Pph21",
                  dataIndex: "pph21",
                  key: "pph21",
                  // align: "right",
                  sorter: {
                      compare: (a, b) => {
                          a = a.pph21.toLowerCase();
                          b = b.pph21.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },
              {
                  title: "Total Salary",
                  dataIndex: "total_amount",
                  key: "total_amount",
                  // align: "right",
                  sorter: {
                      compare: (a, b) => {
                          a = a.total_amount.toLowerCase();
                          b = b.total_amount.toLowerCase();
                          return a > b ? -1 : b > a ? 1 : 0;
                      },
                  },
              },

              // {
              //     title: "Action",
              //     key: "action",
              //     sorter: false,
              // },
      ],

      //filter
      query: "",
      loading: false,
      branchList: [],
        exportBranch: null,
        exportJtrust: null,
    
      //data
      currentData: {
      },
      month: month,
      startDate: new Date,
      endDate: new Date,
    };
  },

  created() {
    const token = Cookies.get("token_refresh");
    this.config = {
      headers: {
        Authorization: `Bearer ` + token,
      },
      timeout: 90000,
    }
    
    localStorage.setItem('actionState', 'view')

    const branch = parseInt(localStorage.getItem("selectedBranch")) || 0;


    this.getBranchFromIndex();

    //Update local and shared state
    this.filter = branch;
    selectedBranch.value = branch;
    
    // Set default date range (1st to last day of current month)
    // Set default date range (1st to last day of current month)
    const storedStart = localStorage.getItem("startCutOff");
    const storedEnd = localStorage.getItem("EndCutOff");

    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth(); // zero-based
    
    // const start = new Date(year, month - 1, storedStart ? parseInt(storedStart) : 1);
    const startDay = storedStart ? parseInt(storedStart) : 1;
    const endDay = storedEnd ? parseInt(storedEnd) : 0;

    const start = new Date(year, month, startDay);

    let end;
    if (startDay === 1) {
        // If start is 1st → end is last day of same month
        end = new Date(year, month + 1, 0);
    } else {
        if (endDay > 0) {
            // If endDay <= startDay, it should be in the *next* month
            if (endDay <= startDay) {
            end = new Date(year, month + 1, endDay);
            } else {
            end = new Date(year, month, endDay);
            }
        } else {
            // fallback if storedEnd missing
            end = new Date(year, month + 1, 0);
        }
    }
    // const end = new Date(year, month, storedEnd ? parseInt(storedEnd) : 0); 

    this.periode = [
      this.formatDateLocal(start),
      this.formatDateLocal(end),
    ];


  },

    mounted() {
        watch(selectedBranch, () => {
            this.index()
        })
        //  { immediate: true }
    },
  
  computed: {
    filteredData() {
      // If no query entered, return all data
      if (this.query === '') {
        return this.data;
      }

      const lowerCaseQuery =  (this.query || '').toLowerCase();

      return this.data.filter(item => {
        return (
          (item.nama_karyawan || '').toLowerCase().includes(lowerCaseQuery) ||
          (item.employee_id2 || '').toLowerCase().includes(lowerCaseQuery) ||
          (item.tunjangan_tetap || '').toLowerCase().includes(lowerCaseQuery) ||
          (item.tunjangan_tidak_tetap || '').toLowerCase().includes(lowerCaseQuery) ||
          (item.tunjangan_transport || '').toLowerCase().includes(lowerCaseQuery) ||
          (item.tunjangan_makan || '').toLowerCase().includes(lowerCaseQuery) ||
          (item.tunjangan_kehadiran || '').toLowerCase().includes(lowerCaseQuery) ||
          (item.tunjangan_lain || '').toLowerCase().includes(lowerCaseQuery) ||
          (item.tunjangan_lain2 || '').toLowerCase().includes(lowerCaseQuery) ||
          (item.additional || '').toLowerCase().includes(lowerCaseQuery) ||
          (item.deduction || '').toLowerCase().includes(lowerCaseQuery) ||
          (item.bpjs_tenaga_kerja || '').toLowerCase().includes(lowerCaseQuery) ||
          (item.bpjs_kesehatan || '').toLowerCase().includes(lowerCaseQuery) ||
          (item.pph21 || '').toLowerCase().includes(lowerCaseQuery) ||
          (item.total_amount || '').toLowerCase().includes(lowerCaseQuery) ||
          (item.jumlah_hari || '').toLowerCase().includes(lowerCaseQuery)
        );
      });
    },

    selectedCompanyIds() {
        if (String(this.exportBranch) === "0") {
        // "All Branch" selected → join all ids except 0
        return this.branchList
            .filter(branch => branch.id !== 0)
            .map(branch => branch.id)
            .join(',');
        } else {
        // Single branch selected → still return string
        return String(this.exportBranch);
        }
    }
  },

  methods: {

    rupiah,
    rupiahNonIdr,

    getNameFileUrl(url) {
      const parts = url.split('/');
      const fileName = parts[parts.length - 1];
      return fileName;
    },

    formatDateLocal(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-based
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    showModal(modal_name) {
        
        const modal = this.$refs[modal_name];
        
        // Show modal
        modal.classList.add('show');
        modal.style.display = 'block';

        // Add backdrop manually
        const backdrop = document.createElement('div');
        backdrop.className = 'modal-backdrop fade show';
        backdrop.setAttribute('data-modal-backdrop', modal_name); // optional attribute to identify
        document.body.appendChild(backdrop);

        // Prevent body scroll
        document.body.classList.add('modal-open');
    },

    hideModal2(modal_name) {
        const modal = this.$refs[modal_name];
        
        // Hide modal
        modal.classList.remove('show');
        modal.style.display = 'none';

        // Remove backdrop
        const backdrop = document.querySelector(`.modal-backdrop[data-modal-backdrop="${modal_name}"]`);
        if (backdrop) backdrop.remove();

        // Remove scroll lock
        document.body.classList.remove('modal-open');
    },

    selectBranch(item) {
      this.exportBranch = item.id;
      console.log('ini isi branch', item)
      localStorage.setItem("selectedExportBranch", item.id);
      localStorage.setItem("namaCompanyExport", item.text);

       
      
      // this.$router.go(0);
    //   selectedBranch.value = item.id
    },


    // for branch select
    getBranchFromIndex() {
        const raw = localStorage.getItem("company_list");
        if (!raw) return;

        try {
          const parsed = JSON.parse(raw); // convert JSON string to array
          this.branchList = [];

          // Push "All Branch" first
          this.branchList.push({ id: 0, text: "-- All Branch --"});

          // Push each company from localStorage
          parsed.forEach(item => {
            const item_prepare = {
              id: item.id,
              text: item.nama_lokasi,
              
            };
            this.branchList.push(item_prepare);
          });

          // Optional: set default selected branch from localStorage
          const storedBranch = localStorage.getItem("selectedBranch");
          const exists = this.branchList.some(
            branch => String(branch.id) === String(storedBranch)
          );

          if (exists) {
            this.exportBranch = storedBranch;
          } else {
            this.exportBranch = 0;
            localStorage.setItem("selectedExportBranch", this.exportBranch);
          }

        } catch (e) {
          console.error("Invalid JSON in company_list:", e);
        }

    },

    async insert() {
        
        let formData = new FormData();
        appendForm(formData)

        formData.append("company_id", this.selectedCompanyIds);

        if (this.periode && this.periode.length === 2) {
            const [startDate, endDate] = this.periode;
            formData.append("dfrom",  startDate);  // end date
            formData.append("dto", endDate);  // start date
        }
        // for (let [key, value] of formData.entries()) {
        //     console.log(key, value);
        // }
        // return;

        const api = base_url + '/v3/reports/report_payroll_excel_filter';
        const res = await axios.post(api, formData, { timeout });
        const data = res.data;
        console.log('ini data overtime:', data)

        if(data.status){
            window.open(data.data.file_report, "_blank");
            this.hideModal2('exportExcel');
            
        }else {
            AlertPopup2("error", "", data.message, true, 1500);
        }

       
        
    },

    onDateChange(value) {
        this.periode = value;
        this.index();
    },

    generateData() {
        this.index()
    },

    async index() {
        this.loading = true;
        
        try {

            let formData = new FormData();
            appendForm(formData)
            // Ensure periode has both start and end dates
            if (this.periode && this.periode.length === 2) {
                const [startDate, endDate] = this.periode;
                formData.append("dfrom",  startDate);  // end date
                formData.append("dto", endDate);  // start date
            }
            
            for (let [key, value] of formData.entries()) {
                console.log(key, value);
            }
            // CloseLoading(); return;
    
            const api = base_url + '/v3/reports/report_payroll';
            const res = await axios.post(api, formData, { timeout });
            const data = res.data;
            console.log('ini data payroll:', data)
            
            if(data.status){
                this.data = [];
                
                const payrollReport = data.data.data_payroll_report;
                payrollReport.forEach((item, index) => {
                    let item_prepare = { ...item, no: (index + 1), };
                    this.data.push(item_prepare);
                });
                
            }else {
                AlertPopup2("error", "", data.message, true, 1500);
            }
        } catch (err) {
            console.error(err);
            AlertPopup2("error", "", "Something went wrong.", true, 1500);
        } finally {
            this.loading = false;
        }

       

    },

    async exportJtrustCSV() {
        const formData = new FormData();
        appendForm(formData)

        formData.append("company_id", this.selectedCompanyIds);

        // Tanggal periode
        if (this.periode && this.periode.length === 2) {
            const [startDate, endDate] = this.periode;
            formData.append("dfrom", startDate);
            formData.append("dto", endDate);
        }
        formData.append("download", "yes");

        for (let [key, value] of formData.entries()) {
            console.log(key, value);
        }
        // return;

        try {
           
            const apiResponse = await axios.post('https://s3-api.jempolku.co.id/v3/jtrust/exportJtrustCSVFilter', formData);
            
            if (!apiResponse.data.status) {
                alert(apiResponse.data.message);
               
                return;
            }

            // Jika backend kirim file URL langsung
            if (apiResponse.data && apiResponse.data.data.download_url) {
                window.open(apiResponse.data.data.download_url, '_blank');
                this.hideModal2('exportJtrust');
                return;
            }

            alert("Gagal export JTrust CSV");
           
            return;
        } catch (error) {
            console.error('Gagal export JTrust CSV:', error);
        }
    }


  }

};
</script>

